/**
  * @brief Send a HTTP or HTTPS request.
  *
  * @param {int}    connectionHandle       Handle of the connection to use for the request 
  * @param {string} httpVerb               "POST" or "GET". 
  * @param {string} urlPath                Path of the request (without domain, ex : "/toto/tata/tutu.svc".
  * @param {string} headers64              Headers list in base64, one couple header:value per line. Eg.: "Content-Type:application/json; charset=utf-8\nHost:toto.com".
  * @param {string} request64              HTTP request in base64. Can be empty.
  */
DMPConnect.prototype.hl_sendHttpRequest = function( connectionHandle, httpVerb, urlPath, headers64, request64, resultCallback )
{
    var command =
    {
        "s_commandName"      : "hl_sendHttpRequest" ,
        "i_connectionHandle" : connectionHandle     ,
        "s_httpVerb"         : httpVerb             ,
        "s_urlPath"          : urlPath              ,
        "s_headersBase64"    : headers64            ,
        "s_requestBase64"    : request64            ,
        "s_sessionId"        : this.getSessionId()
    }

    return this.sendCommand(command, 30, resultCallback);
}